import { Steps, theme } from 'antd';
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import type { CrewStep, StepTone } from '../crewSteps';

const STATUS: Record<StepTone, 'wait' | 'process' | 'finish' | 'error'> = {
  wait: 'wait',
  active: 'process',
  done: 'finish',
  revise: 'finish',
  failed: 'error',
  stopped: 'wait',
  skipped: 'wait',
};

/** The steps strip: Case -> EMS -> CA -> Checks -> Compliance (round n/2) -> Pack. */
const CrewSteps = ({ steps }: { steps: CrewStep[] }) => {
  const { token } = theme.useToken();
  return (
    <Steps
      size="small"
      labelPlacement="vertical"
      style={{ margin: '4px 0 8px' }}
      items={steps.map((step) => ({
        title: step.title,
        description: step.description,
        status: STATUS[step.tone],
        icon:
          step.tone === 'active' ? (
            <LoadingOutlined />
          ) : step.tone === 'stopped' ? (
            <MinusCircleOutlined />
          ) : step.tone === 'revise' ? (
            <ExclamationCircleOutlined style={{ color: token.colorWarning }} />
          ) : undefined,
      }))}
    />
  );
};

export default CrewSteps;
